/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
enum MediaSwiperFormat {
  Featured = 'Featured',
  Headshot = 'Headshot',
  Standard = 'Standard',
}

export default MediaSwiperFormat;
